import { expenseCategoryDeleteApi } from "../../api/expenseCategory/expenseCategoryDeleteApi"

type PayloadShape = Parameters<typeof expenseCategoryDeleteApi>[0]

export async function expenseCategoryDeleteService(payload: PayloadShape, token: string) {
	return await expenseCategoryDeleteApi(payload, token)
}
